import { render, staticRenderFns } from "./PointsRechargeRecords.vue?vue&type=template&id=26e25e38&scoped=true&"
import script from "./PointsRechargeRecords.vue?vue&type=script&lang=js&"
export * from "./PointsRechargeRecords.vue?vue&type=script&lang=js&"
import style0 from "./PointsRechargeRecords.vue?vue&type=style&index=0&id=26e25e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e25e38",
  null
  
)

export default component.exports